export default {
  path: '/',
  component: () => import('src/modules/app/pages/Dashboard'),
  children: [
    {
      path: '',
      name: 'home',
      component: () => import('src/modules/app/pages/HomePage'),
      meta: {
        title: 'Tableau de bord'
      }
    },
    {
      path: '/app-settings',
      name: 'appSettings',
      component: () => import('src/modules/app/pages/ApplicationSettingsUpdate'),
      meta: {
        title: 'Configuration de l\'application',
        admin: true
      }
    },
    {
      path: '/services',
      name: 'services',
      component: () => import('src/modules/services/pages/MyService'),
      meta: {
        title: 'Mes services'
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('src/modules/profile/pages/ProfileUpdate'),
      meta: {
        title: 'Mon profil'
      }
    },
    {
      path: '/devices',
      name: 'trusted-devices',
      component: () => import('src/modules/devices/pages/TrustedDevices'),
      meta: {
        title: 'Mes appareils'
      }
    }
  ]
}
